import { ComplianceType, UploadedDocument } from "@/types"

import {
  CreatePaymentsClientPayload,
  createPaymentsClient,
  getPaymentsClientByEmail,
  PaymentsClient,
  PaymentsApiError,
  updatePaymentsClient,
} from "@/api"

export const getApiErrorMessage = (error: unknown) => {
  if (error instanceof PaymentsApiError) {
    if (error.status === 401) return "Session expired. Please log in again."
    if (error.status === 403) return "You are not authorized to perform this action."
    return error.message
  }
  if (typeof error === "string") return error
  if (error instanceof Error) return error.message
  return "Unexpected error. Please try again."
}

export const ensurePaymentsClient = async (payload: CreatePaymentsClientPayload): Promise<PaymentsClient> => {
  const existingClient = await getPaymentsClientByEmail(payload.email)

  if (!existingClient) {
    try {
      return await createPaymentsClient(payload)
    } catch (error) {
      // 409 = email already exists (race condition). Re-fetch and update instead.
      if (error instanceof PaymentsApiError && error.status === 409) {
        const retryClient = await getPaymentsClientByEmail(payload.email)
        if (retryClient) {
          return updatePaymentsClient(retryClient.id, {
            first_name: payload.first_name,
            last_name: payload.last_name,
            company_name: payload.company_name,
            address_line1: payload.address_line1,
            city: payload.city,
            state: payload.state,
            zip: payload.zip,
            country: payload.country,
          })
        }
      }
      throw error
    }
  }

  return updatePaymentsClient(existingClient.id, {
    first_name: payload.first_name,
    last_name: payload.last_name,
    company_name: payload.company_name,
    address_line1: payload.address_line1,
    city: payload.city,
    state: payload.state,
    zip: payload.zip,
    country: payload.country,
  })
}


export const isCompleted = (type: ComplianceType, complianceDocuments: UploadedDocument[]) => {
  if (type === ComplianceType.NDA) {
    return complianceDocuments.some(doc => doc.name.toLowerCase().includes("eso mutual nda"))
  } else if (type === ComplianceType.BACKGROUND_CHECK) {
    return complianceDocuments.some(doc => doc.name.toLowerCase().includes("background check permission form"))
  }
  return false
}
